import * as React from 'react'
import { cn } from '@/lib/utils'

interface ScrollAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  viewportClassName?: string
}

export const ScrollArea = ({ className, children, viewportClassName, ...props }: ScrollAreaProps) => (
  <div className={cn('relative overflow-hidden', className)} {...props}>
    <div className={cn('h-full w-full overflow-y-auto overflow-x-hidden pr-2', viewportClassName)}>{children}</div>
  </div>
)

export default ScrollArea
